import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Button } from '@mui/material';
import JsonViewer from '@uiw/react-json-view';
import { useNotify } from 'react-admin';
import { useJsonViewStyle } from '../../../Components/Layout/jsonViewTheme';

export const JsonView = ({ value }: { value: unknown }) => {
  const notify = useNotify();
  const style = useJsonViewStyle({ fontSize: 12 });
  const copy = async () => {
    try {
      if (!navigator.clipboard) throw new Error('Clipboard API unavailable');
      await navigator.clipboard.writeText(JSON.stringify(value, null, 2));
      notify('Copied JSON to clipboard', { type: 'info' });
    } catch {
      notify('Could not copy to clipboard', { type: 'warning' });
    }
  };
  return (
    <Box>
      <Button size="small" startIcon={<ContentCopyIcon />} onClick={copy} sx={{ mb: 1 }}>
        Copy
      </Button>
      <JsonViewer value={value as object} collapsed={2} displayDataTypes={false} style={style} />
    </Box>
  );
};
